import React from 'react';
import {Divider} from 'antd'
import {QueryQuestionCount} from '../../../online'
import * as local_urls from '../../../../constants/constants_url';

const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;
import QuestionCategoryRadioSelect from '../../bankQuestion/questionCategorySelect/questionCategoryRadioSelect';

export const staticwizTabelColumns = (self) => [
  {
    title: '题目类型',
    dataIndex: 'typeChar',
    key: 'typeChar',
    width: 60
  },
  {
    title: '题目编码',
    dataIndex: 'number',
    key: 'number',
    width: 60
  },
  {
    title: '题目内容',
    dataIndex: 'title',
    key: 'title',
    width: 140
  },
  {
    title: '难度',
    dataIndex: 'difficultyTitle',
    key: 'difficultyTitle',
    width: 60
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 80,
    render: (text, record) => (
      <span>
          <a onClick={e => self.deleteRow(record)}>删除</a>
      </span>
    ),
  },
];

export const dynamicWizTableColumns = (self, score) => [
  {
    title: '题目分类',
    dataIndex: 'questionCategoryTitle',
    key: 'questionCategoryTitle',
    width: 200
  },
  {
    title: '抽题总数',
    dataIndex: 'total',
    key: 'total',
    width: 80
  },
  {
    title: '总分',
    dataIndex: 'score',
    key: 'score',
    width: 80,
    render: (text, record) => (
      <div>{(score || 0) * record.total}</div>
    ),
  },
  {
    title: '题型',
    dataIndex: 'typeTitle',
    key: 'typeTitle',
    width: 100
  },
  {
    title: '难度',
    dataIndex: 'difficultyTitle',
    key: 'difficultyTitle',
    width: 80
  },


  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 80,
    render: (text, record) => (
      <span>
              <a onClick={e => self.editRow(record)}> 编辑</a>
              <Divider type="vertical"/>
               <a onClick={e => self.deleteDynamicRow(record)}>删除</a>
          </span>
    ),
  },
];

export const dynamicWizModalFormColumns = (self, data) => {
  let questionCategory
  if (data['questionCategory']) {
    questionCategory = data['questionCategory']
  } else {
    questionCategory = []
  }
  return [
    {
      name: "id",
      formItem: {
        type: "hidden",
      }
    },
    {
      name: "order",
      formItem: {
        type: "hidden",
      }
    },
    {
      title: "题目分类",
      name: "questionCategory",
      dataIndex: "questionCategory",
      tableItem: {},
      formItem: {
        type: 'diy',
        selects: questionCategory,
        categoryType: '2',
        checkable: false,
        diy: QuestionCategoryRadioSelect,
        rules: [
          {
            required: true,
            message: '请选择题目分类',
          }
        ],
      }
    },

    // {
    //   title: "题目分类",
    //   name: "questionCategory",
    //   dataIndex: "questionCategory",
    //   tableItem: {},
    //   formItem: {
    //     type: 'diy',
    //     diy: WizClassifySelectRe,
    //     returnKey: true,
    //     initSelects: questionCategory,
    //     wizTreeSelectListProps: {
    //       checkable: false,
    //       itemProps: {
    //         icon: 'unordered-list',
    //         title: '题目分类',
    //         tips: '请勾选所属题目分类'
    //       },
    //       treeProps: {checkStrictly: true}
    //     },
    //     apiProps: {type: 2, state: 1},
    //     selectProps: {
    //       placeholder: '请选择题目分类'
    //     },
    //     rules: [
    //       {
    //         required: true,
    //         message: '请选择题目分类',
    //       }
    //     ],
    //   }
    // },

    {
      title: "符合题型",
      name: "type",
      dataIndex: "type",
      dict: [
        {code: 0, codeName: "单选题"},
        {code: 1, codeName: "多选题"},
        {code: 2, codeName: "判断题"},
        {code: 3, codeName: "填空题"},
        {code: 4, codeName: "主观题"}
      ],
      tableItem: {},
      formItem: {
        type: "select",
        rules: [
          {
            required: true,
            message: '请选择符合题型',
          }
        ],
        allowClear: true
      }
    },
    {
      title: "难度",
      name: "difficulty",
      dataIndex: "difficulty",
      dict: [
        {code: 0, codeName: "低"},
        {code: 1, codeName: "中"},
        {code: 2, codeName: "高"}
      ],
      tableItem: {
        type: "select"
      },
      searchItem: {},

      formItem: {
        type: "select",
        rules: [
          {
            required: true,
            message: '请选择难度',
          }
        ],
        allowClear: true
      }
    },
    {
      title: "抽题总数",
      name: "total",
      dataIndex: "total",
      tableItem: {},
      formItem: {
        rules: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正确的题目数量"
          }
        ]
      }
    },
    {
      title: '',
      name: 'links',
      formItem: {
        type: 'diy',
        links: ['questionCategory', 'type', 'difficulty', 'order'],
        diy: ({
                linksValues
              }) => {
          const {questionCategory, type, difficulty, order} = linksValues
          return <QueryQuestionCount questionCategory={questionCategory} type={type}
                                     changeCount={(value) => self.count = value} difficulty={difficulty}/>
        }
      }
    },
  ]
};
